import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ApiUtilsService {

  sanitizeObject(
    value: { [key: string]: any | any[]},
    sanitizeValues: unknown[] = [null, undefined]
  ): { [key: string]: string | string[] } {

    return Object.keys(value).reduce((res, key: string) => {
      const v = value[key];
      if (sanitizeValues.indexOf(v) < 0) {
        const vv = !(v instanceof Array) ? v.toString() : v.map(x => x.toString());
        res[key] = vv;
      }
      return res;
    }, {} as { [key: string]: string | string[]});

  }
}
